import { navigate } from '@reach/router';
import queryString from 'query-string';

const navigateWithQuery = (uri, query) => {
  navigate(`${uri}?${queryString.stringify(query)}`);
};

export default navigateWithQuery;
